import { Button, Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from 'react-redux';
import { Link as RouterLink } from "react-router-dom";
import { EmptyState } from "components";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
    padding: 0,
    paddingBottom: "0 !important"
  },
  actions: {
    flexDirection: "column",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
}));

const ActiveModules = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.student);
  const classes = useStyles();
  if (!model) return null;
  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title="Active Modules" />
      <Divider />
      <CardContent className={classes.content}>
        {model.active_modules.length > 0 &&
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>XP Obtained</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {model.active_modules.map((mmodule, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.header}>
                    {mmodule.name_en}{mmodule.name_zh ? " " + mmodule.name_zh : ""}
                    <div><Typography variant="caption">{mmodule.code}</Typography></div>
                  </TableCell>
                  <TableCell>
                    {mmodule.user_module.xp_obtained}
                    <div><Typography variant="caption">XP</Typography></div>
                  </TableCell>
                  <TableCell align="right">
                    <Button color="primary" component={RouterLink} size="small" to={`/modules/${mmodule.id}/summary`} variant="outlined">
                      View
                </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        }
        <EmptyState active={!model.active_modules.length} message="This student has no active modules" />
      </CardContent>
    </Card>
  );
};

ActiveModules.propTypes = {
  className: PropTypes.string,
};

export default ActiveModules;
